import { useState } from 'react'
import BackButtonAndTitle from '../../components/retailer-shop/BackButtonAndTitle'
import RetailProductPickerModal from '../../components/retailer-products/RetailProductPickerModal'
import SelectedProductForm from '../../components/retailer-products/SelectedProductForm'
import RetailerProductForm from '../../components/retailer-products/RetailerProductForm'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { useHistory } from '../../contexts/HistoryContext'

const RetailerProductPage = () => {
  const [showProductPicker, setShowProductPicker] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [showNewProductForm, setShowNewProductForm] = useState(false)
  const { goBackOrHome } = useHistory()

  const handleProductSelect = (product) => {
    setSelectedProduct(product)
    setShowProductPicker(false)
  }

  const handleBackToSelection = () => {
    setSelectedProduct(null)
    setShowProductPicker(false)
  }

  const handleShowNewProductForm = () => {
    setShowNewProductForm(true)
    setSelectedProduct(null)
  }

  const renderContent = () => {
    if (showNewProductForm) {
      return (
        <div>
          <RetailerProductForm />
        </div>
      )
    }

    if (selectedProduct) {
      return (
        <SelectedProductForm selectedProduct={selectedProduct} onBack={handleBackToSelection} />
      )
    }

    return (
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-secondary-600/5 to-secondary-600/10 border-2 border-secondary-600/20 rounded-2xl p-6 shadow-lg">
          <div className="text-center mb-4">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-secondary-600/10 rounded-full mb-3">
              <MagnifyingGlassIcon className="w-8 h-8 text-secondary-600" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Quick & Easy Setup</h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              Browse thousands of products and start selling immediately.
              <br />
              Just set your price and you're ready to go!
            </p>
          </div>

          <button
            onClick={() => setShowProductPicker(true)}
            className="w-full bg-gradient-to-r from-secondary-600/80 to-secondary-600/100 text-white rounded-xl px-6 py-4 shadow-lg hover:from-secondary-600/6 hover:to-secondary-600/8 transform hover:scale-[1.02] transition-all duration-200 font-semibold text-lg"
          >
            <div className="flex items-center justify-center gap-3">
              <MagnifyingGlassIcon className="w-6 h-6" />
              Browse Products to Resell
            </div>
          </button>
        </div>

        <div className="pt-4 border-t border-gray-200">
          <div className="text-center">
            <p className="text-gray-500 text-xs mb-2">Need something specific?</p>
            <button
              onClick={handleShowNewProductForm}
              className="text-gray-600 hover:text-gray-800 text-sm font-medium inline-flex items-center gap-1 group"
            >
              <span className="border-b border-dotted border-gray-400 group-hover:border-gray-600">
                Add your own product instead
              </span>
              <svg
                className="w-3 h-3 opacity-60"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>

        {showProductPicker && (
          <RetailProductPickerModal
            onClose={() => setShowProductPicker(false)}
            onSelect={handleProductSelect}
          />
        )}
      </div>
    )
  }

  const onBack = () => {
    if (showNewProductForm) {
      setShowNewProductForm(false)
      setSelectedProduct(null)
      return
    }

    goBackOrHome()
  }

  return (
    <div className="main-container">
      <BackButtonAndTitle onBack={onBack} title="Add Product" />
      {renderContent()}
    </div>
  )
}

export default RetailerProductPage
